module.exports = __webpack_public_path__ + "img/calendar-warning.abb041c5.svg";